var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"see-more",attrs:{"to":_vm.path}},[_vm._v("查看更多")])
}
var staticRenderFns = []

export { render, staticRenderFns }